import { Box, Stack, xcss } from '@atlaskit/primitives';
import React from 'react';
import SearchIcon from '../../assets/SearchIcon.svg';
const wrapperStyles = xcss({
  paddingBlock: 'space.500'
});
const mainTextStyles = xcss({
  fontSize: '1rem',
  fontWeight: 600,
  textAlign: 'center',
  color: 'color.text'
});
const secondaryTextStyles = xcss({
  fontSize: '0.875rem',
  fontWeight: 400,
  color: 'color.text.subtle'
});
/**
 *  Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomNoOptionsMessage` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomNoOptionsMessageInternal = _ref => {
  let {
    showNoSearchResultsText
  } = _ref;
  return /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "center",
    alignInline: "center",
    space: "space.250",
    xcss: wrapperStyles
  }, /*#__PURE__*/React.createElement("img", {
    src: SearchIcon,
    alt: "",
    width: "120px"
  }), /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: mainTextStyles
  }, "No options found"), showNoSearchResultsText && /*#__PURE__*/React.createElement(Box, {
    xcss: secondaryTextStyles
  }, "Try searching for another")));
};

/**
 * The `NoOptionsMessage` component is rendered by React Select in two scenarios:
 * 1. When there are no dropdown option provided to the Select component
 * 2. When there are dropdown options available, but the user has entered a search query that matches none of the options
 */
export const CustomNoOptionsMessage = _ref2 => {
  let {
    selectProps: {
      options
    }
  } = _ref2;
  // Only display secondary no options text when there are dropdown options (option 2 above)
  const showNoSearchResultsText = options.length > 0;
  return /*#__PURE__*/React.createElement(CustomNoOptionsMessageInternal, {
    showNoSearchResultsText: showNoSearchResultsText
  });
};